import {customElement, inject, ObserverLocator, PLATFORM, DOM, Disposable} from 'aurelia-framework';
import {I18N} from 'aurelia-i18n';
import {BreakpointsService} from '../../../services/breakpoints-service';
import {ContentService} from '../../../services/content-service';
import {CustomerService} from '../../../services/customer-service';
import {User, UserDetails} from '../../../services/user-service';

@inject(DOM.Element, I18N, BreakpointsService, ContentService,CustomerService,UserDetails,ObserverLocator)
@customElement('access-menu')
export class AccessMenu {
  buttonEl: HTMLButtonElement;
  visible: boolean = false;
  breakpoints: {[key: string]: number};
  _userData: Partial<User>;
  subscription: Disposable;
  data_wide: any;
  data_narrow: any;
  data_top: any;
  menuClass: string;
  data_bottom: any;
  popUpError: boolean;

  constructor(public el: Element, private _i18n: I18N, public breakpointsService: BreakpointsService, private __contentService: ContentService, private _cs: CustomerService, public userDetails: UserDetails, private _observerLocator: ObserverLocator) {
    this.breakpoints = breakpointsService.getBreakPoints();
    this._userData = userDetails.data;
  }

  attached() {
    let callback;
    const observer = this._observerLocator
      .getObserver(this._userData, 'isCallEnabled');
    observer.subscribe(callback = () => {
      this.setData();
    });
    this.setData();
    this.subscription = {
      dispose() {
       observer.unsubscribe(callback);
      }
    }
  }
  detached() {
    this.subscription.dispose();
  }
  openKeyPad() {
    this.__contentService.showKeypad();
  }
  setData() {
    this.data_wide = [
      { icon: 'ic_contacts',
        label: this._i18n.tr('head.menu.contacts'),
        isVisible: true,
        click: e => this.__contentService.openContacts()
      },
      { icon: 'ic_ringplan',
        label: this._i18n.tr('head.menu.ring_plans'),
        isVisible: this._userData.isCallEnabled,
        click:() =>this.__contentService.openRingplans()
      },
      { icon: 'ic_group',
        label: this._i18n.tr('head.menu.group_mng'),
        isVisible: true,
        click:() =>this.__contentService.openGroupSettings()
      },
      { icon: 'ic_widget',
        label: this._i18n.tr('head.menu.widgets'),
        isVisible:true,
        click:e => this.__contentService.openWidgets()
      }];
    this.data_narrow = [
      { icon: 'ic_onebox',
        label: this._i18n.tr('head.onebox'),
        isVisible: true,
        click: e => this.__contentService.openOnebox()
      },
      { icon: 'ic_alerts',
        label: this._i18n.tr('head.notifications'),
        isVisible:true,
        click: e => this.__contentService.openNotifications()
      },
      { icon: 'ic_group',
        label: this._i18n.tr('head.menu.group_mng'),
        isVisible: true,
        click:() =>this.__contentService.openGroupSettings()
      },
      { icon: 'ic_contacts',
        label: this._i18n.tr('head.menu.contacts'),
        isVisible:true,
        click:e =>this.__contentService.openContacts()
      },
      { icon: 'ic_ringplan',
        label: this._i18n.tr('head.menu.ring_plans'),
        isVisible:this._userData.isCallEnabled,
        click:() => this.__contentService.openRingplans()
      },
      { icon: 'ic_widget',
        label: this._i18n.tr('head.menu.widgets'),
        isVisible:true,
        click:e => this.__contentService.openWidgets()
      },
      { icon: 'ic_help',
        label: this._i18n.tr('head.menu.help'),
        isVisible:true,
        click: e => this.openHelp()
      }, {
        icon: 'ic_home',
        label: this._i18n.tr('head.menu.home'),
        isVisible:true,
        click: e => this.goHome()
      }];
    if (!this._cs.customHost()) {
      this.data_narrow.push({
          icon: 'icon2-86_ic',
          label: this._i18n.tr('head.home'),
          click: e => PLATFORM.global.open('/?language=' + this._i18n.getLocale(), '_blank')
      });
    }
    if (PLATFORM.global.innerWidth > this.breakpoints['$md-min-width']) {
      this.data_top = this.data_wide;
      this.el.classList.remove('menu-narrow');
      this.menuClass = 'right';
    } else {
      this.data_top = this.data_narrow;
      this.el.classList.add('menu-narrow');
      this.menuClass = 'right';
    }
    this.data_bottom = [{
      icon: 'ic_keypad',
      label: this._i18n.tr('head.menu.keypad'),
      isVisible: this._userData.isCallEnabled,
      click: e => this.__contentService.showKeypad(),
      separator:true
    }];
  }
  openHelp() {
    let helpWin = PLATFORM.global.open('http://86borders.zendesk.com', '_blank');
    // if (this.help && this.help.style) {
    //   this.help.style.display = 'block';
    // }
    console.log(helpWin);
    try {
      helpWin.focus();
    }    catch (e) {
      this.visible = false;
      this.popUpError = true;
    }
  }

  goHome() {
    let language = this._i18n.getLocale();
    //PLATFORM.location.replace("/?language="+language);
    let homeWin = PLATFORM.global.open('/?language=' + language, '_blank');
    try {
      homeWin.focus();
    }    catch (e) {
      this.visible = false;
      this.popUpError = true;
    }
  }
}
